import "./styles/styles.scss";
import Vue from "vue";
import App from "./App.vue";
import store from './Store'
import vuetify from "./plugins/vuetify";
import router from "./router";
import * as VueGoogleMaps from "vue2-google-maps";
import { mapApiKey } from "./config";
import VueYoutube from 'vue-youtube';
import VueI18n from 'vue-i18n';

import "./assets/widget.js"
import 'vue-loading-overlay/dist/vue-loading.css';
import VueSocialSharing from 'vue-social-sharing'

Vue.use(VueSocialSharing)


Vue.use(VueI18n);
import th_words from './util/lang/th';
import en_words from './util/lang/en';

const i18n = new VueI18n({
  //construction a new VueI18n
  locale: store.state.Branch.lang,
  fallbackLocale: "th", //always displays English if Thai translation is not available
  messages: {
    //'locales' directory contains all the translations in the form of json files
    en: en_words,
    th: th_words
  }
});
// Vue.prototype._i18n = i18n;
import {DateFormatUtil} from './util/DateFormatUtil';
Vue.prototype.dateFormatUtil = DateFormatUtil;
Vue.use(require('vue-moment'));
Vue.use(VueYoutube);
Vue.use(VueGoogleMaps, {
  load: {
    key: mapApiKey,
    libraries: "places", // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true,
});
Vue.config.productionTip = false
Vue.config.silent = true

new Vue({
  vuetify,
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount("#app");
